module.exports = __webpack_public_path__ + "media/images/signup-graphic-b4a12cbf.jpg";